import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import Loading from "../../../../pages/Loading/Loading";

const MenuPrintTags = lazy(
  () => import("../../../../pages/MenuPrintTags/MenuPrintTags")
);

export const Route = createFileRoute("/$lang/_authenticated/menu-print-tags")({
  component: () => (
    <Suspense fallback={<Loading />}>
      <MenuPrintTags />
    </Suspense>
  )
});
